import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDatePickerComponent } from './custom-date-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [CustomDatePickerComponent],
  imports: [CommonModule, FormsModule, MaterialModule, ReactiveFormsModule],
  exports: [CustomDatePickerComponent],
})
export class CustomDatePickerModule {}
